module.exports = __webpack_public_path__ + "img/icon-opera.61e1ed9c.svg";